import Box from "@mui/material/Box";
import Sidebar from "../sidebar/sidebar";
import { Outlet, useParams } from "react-router-dom";
import Main from "./main";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import APIErrorNotification from "../error/snackbar";
import ErrorPage from "../../pages/error/error";
import { getLabelByCustomerId } from "../../api/label-api";
import FeedbackButton from "../feedback/feedback-button";
import {
  Alert,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Snackbar,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import FeedbackForm from "../feedback/feedback-form";
import { WizardContextProvider } from "../../common/providers/WizardProvider";

const supportedEconomicProfiles: (string | undefined)[] = ["foretag", "privat"];

export default function CustomerArea() {
  let { customer, economicProfile } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [customerName, setCustomerName] = useState<string>();

  const [displayFeedbackForm, setDisplayFeedbackForm] = useState(false);
  const [
    displayFeedbackSuccessfullySentMessage,
    setDisplayFeedbackSuccessfullySentMessage,
  ] = useState(false);

  useEffect(() => {
    getLabelByCustomerId("CustomerName", customer, economicProfile)
      .then((response) => {
        setCustomerName(response?.description ?? undefined);
      })
      .finally(() => setIsLoading(false));
  }, [customer, economicProfile]);

  if (isLoading) return null;

  return (
    <Box sx={{ display: "flex", position: "relative" }}>
      <Helmet>
        <title>
          {"Fjärrkontrollen" + (customerName ? ` - ${customerName}` : "")}
        </title>
      </Helmet>
      {customerName && supportedEconomicProfiles.includes(economicProfile) ? (
        <WizardContextProvider
          customer={customer!}
          economicProfile={economicProfile!}
        >
          <Sidebar customer={customer} economicProfile={economicProfile} />
          <Main customer={customer} economicProfile={economicProfile}>
            <Outlet />
            <APIErrorNotification />
            <Snackbar
              open={displayFeedbackSuccessfullySentMessage}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              autoHideDuration={3000}
              onClose={() => {
                setDisplayFeedbackSuccessfullySentMessage(false);
              }}
            >
              <Alert severity="success">Feedbacken har skickats in</Alert>
            </Snackbar>
            {customer && economicProfile && (
              <FeedbackButton
                onClick={() => {
                  setDisplayFeedbackForm(true);
                  setDisplayFeedbackSuccessfullySentMessage(false);
                }}
              />
            )}
            <Dialog
              fullWidth
              maxWidth="sm"
              open={displayFeedbackForm}
              onClose={() => setDisplayFeedbackForm(false)}
            >
              <DialogContent>
                <DialogActions>
                  <IconButton
                    size="small"
                    onClick={() => setDisplayFeedbackForm(false)}
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </DialogActions>
                <FeedbackForm
                  customer={customer!}
                  economicProfile={economicProfile!}
                  url={window.location.href}
                  onSuccessfulSend={() => {
                    setDisplayFeedbackForm(false);
                    setDisplayFeedbackSuccessfullySentMessage(true);
                  }}
                />
              </DialogContent>
            </Dialog>
          </Main>
        </WizardContextProvider>
      ) : (
        <Main>
          <ErrorPage error={"Sidan hittades inte"} />
        </Main>
      )}
    </Box>
  );
}
